import { render } from "./MissedReason.vue?vue&type=template&id=5b04c1a4&scoped=true"
import script from "./MissedReason.vue?vue&type=script&lang=js"
export * from "./MissedReason.vue?vue&type=script&lang=js"

import "./MissedReason.vue?vue&type=style&index=0&id=5b04c1a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b04c1a4"]])

export default __exports__